import React, { Component } from 'react';

class Setting extends Component {
	render() {
		return (
		<div className="Setting">
			<div className="WorldMap">
				<div className="SettingTitle">La Carte du Monde Connu</div>
				<div className="WorldMapImage" />
			</div>
			<div className="Pantheon">
				<div className="SettingTitle">Le Panthéon des Dieux</div>
				<div className="PantheonList">
					<div className="God">
						<div className="GodIcon Tears"></div>
						<div className="GodDescription">
							<div className="GodName">La Dame aux Larmes de Fer</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Une femme impassible avec des larmes le long des joues</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Stoïcité, Perte, Ascension par la Souffrance</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Loyal</div>
							</div>
						</div>
					</div>

					<div className="God">
						<div className="GodIcon Gaunt"></div>
						<div className="GodDescription">
							<div className="GodName">Le Décharné</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Un homme extrêmement maigre au visage déterminé</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Le Travail, Le Sacrifice de Soi, L'Endurance</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Loyal</div>
							</div>
						</div>
					</div>	

					<div className="God">
						<div className="GodIcon Scarab"></div>
						<div className="GodDescription">
							<div className="GodName">Le Scarabé Mécanique</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Un scarabé fait de milliers de pièces d'horlogerie</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Les Mécanismes Complexes, L'Ingéniosité, Les Pièges</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Loyal</div>
							</div>
						</div>
					</div>				
					
					<div className="God">
						<div className="GodIcon Drowned"></div>
						<div className="GodDescription">
							<div className="GodName">La Déesse Noyée</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Une femme capturée par une pieuvre</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">La Mer, La Tempête, Les Marins Noyés</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Neutre</div>
							</div>
						</div>
					</div>
					
					<div className="God">
						<div className="GodIcon Ombre"></div>
						<div className="GodDescription">
							<div className="GodName">L'Ombre Dansante</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Une silhouette de femme qui danse</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Les Assassins, La Danse et la Musique, La Subtilité</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Neutre</div>
							</div>
						</div>
					</div>
					
					<div className="God">
						<div className="GodIcon Worm"></div>
						<div className="GodDescription">
							<div className="GodName">Le Ver Conquérant</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Un gigantesque ver qui avale le monde</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">La Mort, Le Renouvellement, Le Déclin inévitable</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Neutre</div>
							</div>
						</div>
					</div>
					
					<div className="God">
						<div className="GodIcon Traveler"></div>
						<div className="GodDescription">
							<div className="GodName">La Voyageuse</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Une poule à quatre têtes (une pour chaque saison)</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Le Voyage, L'Hospitalité, Les Saisons, Les Fêtes de Village</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Neutre</div>
							</div>
						</div>
					</div>
					
					<div className="God">
						<div className="GodIcon Teeth"></div>
						<div className="GodDescription">
							<div className="GodName">La Mère des Dents</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Une vieille femme bossue portant une couronne de fleurs mortes</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent"> Enfants, Famine, Choix difficiles</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Neutre</div>
							</div>
						</div>
					</div>
					
					<div className="God">
						<div className="GodIcon Shuffler"></div>
						<div className="GodDescription">
							<div className="GodName">Le Vieux Batteur</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Un corbeau à deux têtes, une qui dit vrai, et une qui dit faux</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Farces, Anarchie, Jeu</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Chaotique</div>
							</div>
						</div>
					</div>
					
					<div className="God">
						<div className="GodIcon Horned"></div>
						<div className="GodDescription">
							<div className="GodName">L'Homme Cornu</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Un homme avec des cornes de cerfs</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Chasse, Transe, La Nature</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Chaotique</div>
							</div>
						</div>
					</div>
					
					<div className="God">
						<div className="GodIcon Devourer"></div>
						<div className="GodDescription">
							<div className="GodName">Le Dévoreur</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Un guerrier avec une énorme bouche et les dents pointues</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Art, Guerre, Sensualité</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Chaotique</div>
							</div>
						</div>
					</div>
					<div className="God">
						<div className="GodIcon Dragon"></div>
						<div className="GodDescription">
							<div className="GodName">Le Rêveur</div>
							<div className="GodAppearance">
								<div className="GodAppearanceTitle">Apparance</div>
								<div className="GodAppearanceContent">Un dragon de fumée blanche</div>
							</div>
							<div className="GodQualities">
								<div className="GodQualitiesTitle">Domaine</div>
								<div className="GodQualitiesContent">Rêve, Hypnose, Drogue</div>
							</div>
							<div className="GodAlignment">
								<div className="GodAlignmentTitle">Alignement</div>
								<div className="GodAlignmentContent">Chaotique</div>
							</div>
						</div>
					</div>					
				</div>
			</div>
        
		</div>
		);
	}
}

export default Setting;